import { ReactNode } from 'react'

interface Tab {
  id: string
  label: string
  count?: number
  visible?: boolean
  suffix?: ReactNode
}

interface TabBarProps {
  tabs: Tab[]
  activeTab: string
  onTabChange: (id: string) => void
  size?: 'sm' | 'md'
  className?: string
}

const sizeClasses = {
  sm: 'px-3 py-2 text-sm',
  md: 'px-4 py-2 text-sm',
}

export const TabBar = ({ tabs, activeTab, onTabChange, size = 'md', className = '' }: TabBarProps) => (
  <div className={`flex gap-1 border-b border-gray-200 min-w-0 ${className}`}>
    {tabs
      .filter((t) => t.visible !== false)
      .map((tab) => (
        <button
          key={tab.id}
          onClick={() => onTabChange(tab.id)}
          className={`${sizeClasses[size]} font-medium border-b-2 whitespace-nowrap transition-colors -mb-px ${
            activeTab === tab.id
              ? 'border-primary-600 text-primary-700'
              : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
          }`}
        >
          {tab.label}
          {tab.count !== undefined && (
            <span className={`ml-1.5 ${activeTab === tab.id ? 'text-primary-500' : 'text-gray-400'}`}>
              ({tab.count})
            </span>
          )}
          {tab.suffix}
        </button>
      ))}
  </div>
)
